<ul>
    <li *ngFor="let topic of topicsList$ | async">
        {{ topic.subjGroup }} - {{ topic.subjGroupTopic }} ({{ topic.subjActive? "Active" : "NOT active" }}) <a
            [routerLink]="[ topic.id, 'edit']">edit</a>
    </li>
</ul>
